<template>
    <div>
        <div class="modal fade" id="modaldesconto" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Informações do Título</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-4">
                            <label for="edcodtit">Número:</label>
                            <input type="text" class="form-control form-control-sm" disabled id="edcodtit" v-model="codtit" data-bv-group=".group" maxlength="20" title="Número da venda feita no PDV off line">
                        </div>
                        <div class="col-8">
                            <label for="ednomeclidesc">Cliente:</label>
                            <input type="text" class="form-control form-control-sm" disabled id="ednomeclidesc" v-model="cliente" data-bv-group=".group" maxlength="20" title="Número da venda feita no PDV off line">
                        </div>
                        <div class="col-4">
                            <label for="cbtpdesc">Tipo de desconto:</label>
                            <select name="cbentregaexternapesq" class="form-control form-control-sm" id="cbtpdesc" v-model="tpdesconto" @change="mtdrecalcula()">
                                <option value="0">Percentual(%)</option>
                                <option value="1">Valor($)</option>
                            </select>
                        </div>
                        <div class="col-8">
                            <label for="eddescon">Desconto:</label>
                            <money type="text" class="form-control form-control-sm" id="eddescon" @blur.native="mtdrecalcula()" v-model="fatordesconto" v-bind="money" style="text-align:right;"></money>
                        </div>
                        <div class="col-12">
                            <label for="edtotalgeral">Total:</label>
                            <money type="text"  class="form-control form-control-sm" disabled id="edtotalgeral" v-model="total" v-bind="money" style="text-align:right; background-color: rgba(45, 216, 125, 0.291);"></money>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    <button type="button" @click.prevent="mtdaplicadesconto()" class="btn btn-primary">Salvar</button>
                </div>
                </div>
            </div>
        </div>
    </div>
  </template>
  
  <script>
    import util from '../utilitarios/util.js'
  export default {
    name: 'descontotitulo',

    props: [
       'titulo', 
    ],
    data() {
      return {
            codtit: '',          
            cliente: '',       
            tpdesconto: 0,       
            fatordesconto: 0,   
            total: 0  ,
            
            money: {
                decimal         : ',',
                thousands       : '.',
                prefix          : '',//aqui colocar o cifrão se for necessário
                precision       : 2,
                masked          : false
            },
      };
    },
    methods: {
        achapercentualdesconto(){
            if (this.tpdesconto == 0) {
                return this.fatordesconto
            } else {
               return this.total === 0 ? 0 : (this.fatordesconto / 100) * this.total
            }
        },
        mtdrecalcula() {
            this.total = this.titulo.vlresta
            if (!util.opcaousuario('030Z.010Z.120Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
            }else {
                if (this.achapercentualdesconto() >  window.localStorage.getItem('descontotit')){
                    this.$toastr.w('Percentual de desconto não permitido para o seu perfil de usuário!', 'Atenção!');
                    this.fatordesconto = 0
                }else{
                    if (this.tpdesconto == 0) {
                        if(this.fatordesconto > 100){
                            this.fatordesconto = 100
                        }
                        if(this.fatordesconto < 0){
                            this.fatordesconto = 0
                        }
                        this.total = this.total * (1 - this.fatordesconto / 100);
                    } else {
                        this.total = this.total - this.fatordesconto;
                    }
                }
            }
      
        },
        defvalores(){
            let vself    = this
            vself.codtit  = vself.titulo.codtit
            vself.cliente = vself.titulo.idcliente +"-"+ vself.titulo.nomecliente
            vself.total   = vself.titulo.vlresta
        },
        mtdaplicadesconto(){
            if (this.fatordesconto==0){
                this.$toastr.w('Percentual de desconto deve ser informado!', 'Atenção!');
                return
            }
            let vself = this
            $.confirm({
                title: 'Confirmação!',
                content: 'Confirma o desconto no titulo?',
                icon: 'fa fa-question-circle',
                escapeKey: true,
                backgroundDismiss: false,
                escapeKey: 'nao',
                type: 'dark',
                typeAnimated: true,
                buttons: {
                    sim: {
                        text: '<u>S</u>im',
                        keys: ['s', 'S'],
                        btnClass: 'btn-blue',
                        action: function () {
                            $('.btn-blue').prop('disabled', true);
                            vself.mtdregistro();
                        },
                    },
                    nao: {
                        text: '<u>N</u>ão',
                        keys: ['n', 'N'],
                        action: function () {
                            $('#eddescon').focus();
                        }
                    }
                }
            });
        },
        mtdregistro(){
            let vself = this;
            let loader      = vself.$loading.show();
            let registrocrud = {
                'codtit'   : vself.codtit,
                'idcliente': vself.titulo.idcliente,
                'vltit'    : vself.total
            }
            let parametros      = [
                {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'op',           valor : 'descontotitulo'},
                {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                {parametro: 'prvaldesconto',valor : vself.fatordesconto},
                {parametro: 'codop',        valor : '030Z.010Z.120Z'},
            ];
            let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulosreceberv2.php');
            retorno.then(function (response) {
                loader.hide();
                if ($.isNumeric(response.data)){
                    vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                    $('#modaldesconto').modal('hide');
                    setTimeout(() => {
                        $("#btlistar").trigger('click');
                    }, 300);
                   
                  
                }else{
                    let tpret = response.data.substring(0,1);
                    switch (tpret) {
                        case 'I':
                            vself.$toastr.w(response.data.substring(4), 'Atenção!');
                            break;
                        case 'E': default:
                            vself.$toastr.e(response.data.substring(4), 'Erro!');
                            break;
                    }
                }
            }).catch(function (response) {
                loader.hide();
                vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
            });
        },
        resetadados(){
            this.codtit       = ''       
            this.cliente      = ''     
            this.tpdesconto   = 0      
            this.fatordesconto= 0   
            this.total        = 0  
        },
 
    },
    mounted: function () {

            let vself = this;
        $('#modaldesconto').on('shown.bs.modal', function (e) {
            vself.codtit  = vself.titulo.codtit
            vself.cliente = vself.titulo.idcliente +"-"+ vself.titulo.nomecliente
            vself.total   = vself.titulo.vlresta
        });
        $('#modaldesconto').on('hide.bs.modal', function (e) {
            vself.resetadados()
        });
    },
    watch: {
        total(){
            if(this.total < 0){
                this.total = 0
            }
        },
        tpdesconto(){
           this.defvalores();
        }
    },
    computed: {

    }


  };
  </script>
  
  <style>
  </style>